var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07031 18.2827H15.0463C15.3669 18.2828 15.6771 18.1694 15.9221 17.9624C16.167 17.7556 16.3308 17.4688 16.3844 17.1527L18.7703 3.12913C18.8241 2.81323 18.9879 2.52657 19.2329 2.31992C19.4778 2.11326 19.7879 1.99993 20.1084 2H20.9987",
    stroke: "#3B4B52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76897 20.9989C7.58159 20.9989 7.42969 20.847 7.42969 20.6596C7.42969 20.4722 7.58159 20.3203 7.76897 20.3203",
    stroke: "#3B4B52",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 20.9989C7.95691 20.9989 8.10881 20.847 8.10881 20.6596C8.10881 20.4722 7.95691 20.3203 7.76953 20.3203",
    stroke: "#3B4B52",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5541 20.9989C14.3668 20.9989 14.2148 20.847 14.2148 20.6596C14.2148 20.4722 14.3668 20.3203 14.5541 20.3203",
    stroke: "#3B4B52",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5547 20.9989C14.7421 20.9989 14.894 20.847 14.894 20.6596C14.894 20.4722 14.7421 20.3203 14.5547 20.3203",
    stroke: "#3B4B52",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8862 14.2089H5.96498C5.35978 14.2088 4.77196 14.0065 4.29493 13.634C3.8179 13.2616 3.47903 12.7404 3.33217 12.1533L2.02028 6.90573C1.99525 6.80565 1.99337 6.70119 2.01476 6.60027C2.03617 6.49936 2.0803 6.40466 2.14381 6.32336C2.2073 6.24206 2.2885 6.17631 2.38124 6.13111C2.47397 6.08591 2.57578 6.06245 2.67894 6.0625H18.2713",
    stroke: "#3B4B52",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/ShoppingCart.5abdd0920ef239ba4a7d2c07d7e697e1.svg";
export { ForwardRef as ReactComponent };